import type { LegalPageKind } from './LegalPage';

export const resolveLegalPage = (pathname: string): LegalPageKind | null => {
  const normalized = `/${pathname
    .split('?')[0]
    .split('#')[0]
    .replace(/^\/+|\/+$/g, '')}`;
  if (normalized === '/privacy' || normalized === '/privacy-policy') return 'privacy';
  if (normalized === '/terms' || normalized === '/terms-of-service') return 'terms';
  if (normalized === '/cookies' || normalized === '/cookie-policy') return 'cookies';
  return null;
};
